<template>
  <b-card>
    <label class="text__header mb-0">Contract Additional ID</label>
    <div class="row mt-1">
      <div class="col-12 col-md-8 col-lg-6">
        <div
          v-if="
            (!additionalIdList.length && !this.isEnableAddNew) ||
            (!additionalIdList.length && isContractInDeletedStatus)
          "
        >
          <span class="font-size-12"> This Contract has no Additional ID </span>
        </div>

        <div v-else>
          <label class="text-uppercase text-semibold-grey">Additional ID</label>
          <div class="content-overflow-scroll">
            <atom-item-list
              v-for="(additionalId, index) in additionalIdList"
              :key="index"
              textVariant="text-color-black"
              :item="additionalId || '-'"
              :isEnableDeleteItem="isDeletable && !isContractInDeletedStatus"
              @onClickDeleteIcon="deleteAdditionalId(additionalId, $event)"
            ></atom-item-list>
          </div>
          <div
            v-if="
              !isAddingNewAdditionalId &&
              !isContractInDeletedStatus &&
              isEnableAddNew
            "
            class="button-wrapper"
          >
            <div
              class="button-dash box-dashed custom-add-item-btn mt-1"
              @click="onClickAddNewAdditionalIdButton"
            >
              <feather-icon
                class="icon-size-18px text-primary"
                icon="PlusCircleIcon"
              ></feather-icon>
              <label class="button--text">Additional ID</label>
            </div>
          </div>
          <div
            v-else-if="isAddingNewAdditionalId"
            class="d-flex align-items-start mt-1"
          >
            <atom-input
              v-model="newAdditionalId"
              placeholder="Additional ID (Optional)"
              :errorMessage="errorMessageNewAdditionalId"
              :isError="isErrorAtNewAdditionalId"
            ></atom-input>
            <div class="ml-1 d-flex justify-content-end align-items-end">
              <atom-button
                buttonId="confirm-add-new-additional-id"
                :isOnlyIcon="true"
                iconLeft="CheckIcon"
                @click="addNewAdditionalId"
              ></atom-button>
              <atom-button
                buttonId="cancel-add-new-additional-id"
                class="ml-1"
                :isOnlyIcon="true"
                iconLeft="XIcon"
                buttonStyle="border"
                buttonColor="secondary"
                @click="onClickCancelAddNewAdditionalId"
              ></atom-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomItemList from "@/components/atoms/AtomItemList.vue"
export default {
  name: "MoleculeContractAdditionalId",
  components: {
    AtomButton,
    AtomInput,
    AtomItemList,
    BCard,
  },
  props: {
    contractStatus: {
      type: String,
      required: false,
      default: null,
    },
    isEnableAddNew: {
      type: Boolean,
      required: false,
      default: true,
    },
    isDeletable: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["input"],

  data() {
    return {
      newAdditionalId: "",
      isValidate: false,
      isAddingNewAdditionalId: false,
    }
  },

  computed: {
    additionalIdList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
    isContractInDeletedStatus() {
      return this.contractStatus?.toLowerCase() === "deleted"
    },
    trimmedNewAdditionalId() {
      return this.newAdditionalId?.trim() || ""
    },
    isInvalidNewAdditionalId() {
      return !this.trimmedNewAdditionalId
    },
    isDuplicatedNewAdditionalId() {
      return this.additionalIdList.includes(this.trimmedNewAdditionalId)
    },
    isErrorAtNewAdditionalId() {
      if (this.isValidate) {
        return this.isInvalidNewAdditionalId || this.isDuplicatedNewAdditionalId
      } else {
        return false
      }
    },
    errorMessageNewAdditionalId() {
      if (this.isInvalidNewAdditionalId) {
        return "Please enter additional ID"
      } else if (this.isDuplicatedNewAdditionalId) {
        return "This addition ID is already exists"
      }
      return ""
    },
  },

  methods: {
    onClickAddNewAdditionalIdButton() {
      this.isAddingNewAdditionalId = true
    },

    onClickCancelAddNewAdditionalId() {
      this.isAddingNewAdditionalId = false
      this.setDefaultToNewAdditionalId()
    },

    addNewAdditionalId() {
      this.isValidate = true
      if (!this.isErrorAtNewAdditionalId) {
        this.additionalIdList.push(this.trimmedNewAdditionalId)
        this.isAddingNewAdditionalId = false
        this.setDefaultToNewAdditionalId()
      }
    },

    setDefaultToNewAdditionalId() {
      this.newAdditionalId = ""
      this.isValidate = false
    },

    deleteAdditionalId(target) {
      const targetIndex = this.additionalIdList.findIndex(
        (item) => item === target
      )
      this.additionalIdList.splice(targetIndex, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.text__header {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.button-dash {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-dashed {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  color: #b9b9c3;
  border: 1px dashed #7367f0;
  border-radius: 5px;
  &:hover {
    cursor: pointer;
    background-color: #f9f9fe;
  }
}

.content-overflow-scroll {
  max-height: 200px;
  overflow-y: auto;
}
</style>
